import { Paper, Skeleton } from '@/ui';

import type { FC } from 'react';

// Matches MemberAppointmentRow's shape so loading state does not visibly
// jump when the list resolves.
const AppointmentRowSkeleton: FC = () => (
  <Paper
    className="flex min-h-[90px] w-full items-center gap-4 rounded-xl bg-white p-6"
    data-testid="appointment-row-skeleton"
    elevation={1}
  >
    <div className="flex min-w-0 flex-1 flex-col gap-2">
      <Skeleton height={20} variant="rectangular" width={220} />
      <Skeleton height={14} variant="rectangular" width={280} />
    </div>
    <div className="flex shrink-0 items-center gap-2">
      <Skeleton height={36} variant="rectangular" width={96} />
      <Skeleton height={36} variant="rectangular" width={96} />
    </div>
  </Paper>
);

export default AppointmentRowSkeleton;
